<div class="flex h-full flex-col bg-pmdf-primary overflow-y-auto">
  <div class="p-4 border-b border-pmdf-primary-soft">
    <h2 class="text-lg font-display text-pmdf-base-primary">Missões</h2>
  </div>

  <!-- Widget de Ordens de Serviço -->
  <div class="border-b border-pmdf-primary-soft">
    <app-os-quickpanel-widget />
  </div>

  <!-- Atalhos rápidos -->
  @if (flagService.isEnabled('quickpanelAtalhos')) {
    <div class="border-b border-pmdf-primary-soft p-3">
      <h3 class="px-1 pb-2 text-xs font-semibold uppercase tracking-wider text-pmdf-muted-30">
        Atalhos
      </h3>
      <div class="grid grid-cols-3 gap-2">
        @for (shortcut of shortcuts(); track shortcut.route) {
          <button
            type="button"
            matRipple
            class="flex flex-col items-center gap-1.5 p-2.5 rounded-pmdf-card bg-pmdf-surface/10 hover:bg-pmdf-surface/20 transition-colors touch-manipulation"
            (click)="navigateShortcut(shortcut.route)"
          >
            <mat-icon class="icon-base text-pmdf-muted-30">{{ shortcut.icon }}</mat-icon>
            <span class="text-xs text-pmdf-muted-30 leading-tight text-center">{{ shortcut.label }}</span>
          </button>
        }
      </div>
    </div>
  }

  <!-- Notificações -->
  <div>
    <h3 class="px-4 py-2 text-xs uppercase tracking-wider text-pmdf-base-primary mt-2">
      Notificações
    </h3>
    <mat-nav-list class="py-2">
      @for (notification of notifications(); track notification.id) {
        <mat-list-item
          class="cursor-pointer"
          [class.bg-error-50]="notification.priority === 'high'"
          (click)="openNotification(notification)"
        >
          <mat-icon
            matListItemIcon
            class="text-pmdf-base-primary"
            [class.text-error-500]="notification.priority === 'high'"
            [class.text-pmdf-icon]="notification.priority !== 'high'"
          >
            {{ notification.icon }}
          </mat-icon>
          <div matListItemTitle class="font-normal text-pmdf-base-primary">{{ notification.title }}</div>
          <div matListItemLine class="text-sm font-light text-pmdf-muted-70">{{ notification.subtitle }}</div>
          <div matListItemLine class="text-xs font-extralight text-pmdf-muted-70">{{ notification.time }}</div>
        </mat-list-item>
      }
      @if (notifications().length === 0) {
        <div class="py-8 text-center">
          <mat-icon class="icon-3xl opacity-50 mb-3 text-pmdf-base-primary">notifications_none</mat-icon>
          <p class="text-sm font-light text-pmdf-base-primary">Nenhuma notificação pendente</p>
        </div>
      }
    </mat-nav-list>
  </div>
</div>
